/**
 * Какие вкладки вправе перезагрузиться сами, когда новый service worker взял их под управление.
 *
 * С 12.09.2026 worker активируется без согласия, чтобы починка политики безопасности страницы
 * доезжала до людей (см. `sw.ts`); страница узнаёт об этом по `controllerchange` и перезагружает
 * себя (`swUpdate.ts`). Цена — вкладка, перезагруженная посреди дела: на шаге адреса, со сводкой
 * перед оплатой, на возврате из банка. Черновик такое переживает, а вот согласие «всё равно
 * картой», незакрытый лист выбора причины отмены или страница банка в кадре — нет.
 *
 * Поэтому перезагружаются только вкладки «в покое»: списки и экраны без незаконченного ввода.
 * Остальные получают обычное предложение обновиться (`swUpdate.ts`, правило 3), и оно
 * показывается, как только человек выходит из мастера или оплаты (правило 6). Оболочка с новой
 * политикой доедет к ним следующей загрузкой — как и до 12.09, только теперь это касается одной
 * занятой вкладки, а не всех.
 *
 * Список — только на чтение, без форм: проще перечислить, где перезагрузка безобидна, чем
 * угадывать, где она вредна. Новый экран с вводом сюда не попадёт, пока его не добавят руками, —
 * и это правильная сторона ошибки.
 */
const RESTING_PATHS: ReadonlySet<string> = new Set([
  '/',
  '/history',
  '/profile',
  '/cars',
  '/chat',
  '/profile/payment-methods',
  '/login',
]);

/** True, если вкладку с этим адресом можно перезагрузить, не прервав ничего. */
export function isRestingPath(pathname: string): boolean {
  const trimmed = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  return RESTING_PATHS.has(trimmed);
}
